module.exports = __webpack_public_path__ + "img/login.800063aa.jpg";